import * as React from 'react';

import { Bone } from '@lightspeed/flame/Bone';
import { Box, Flex } from '@lightspeed/flame/Core';

export const LoadingBones: React.FC = () => {
  return (
    <Box p={2} data-test="loading-bones">
      <Flex flexDirection="column">
        <Bone height={100} />
        <Flex justifyContent="flex-end" alignItems="center" p={2}>
          <Box pb={2}>
            <Bone height={4} width={150} />
          </Box>
        </Flex>
      </Flex>
    </Box>
  );
};

export default LoadingBones;
